const teamMembers = [
  { initials: 'PA', name: 'Pramod Attarde',  title: 'Founder, CEO & CTO',           cred: 'Apex DeFi Labs Inc.',       photo: '/members/PramodAttarde.png' },
  { initials: 'SA', name: 'Sunita Attarde',  title: 'EVP & Chief Operating Officer', cred: 'Apex DeFi Labs Inc.',       photo: '/members/sunita attarde.jpeg' },
  { initials: 'LS', name: 'Lalit Shinde',    title: 'Corporate Advisor',   cred: 'Apex DeFi Labs Inc.',       photo: '/members/lalitShinde.jpeg' },
  { initials: 'SK', name: 'Sanjay Kamtekar', title: 'Sr. Managing Director',         cred: 'Apex DeFi Labs Inc.',       photo: '/members/sanjay kamtekar.jpeg' },
  { initials: 'IS', name: 'Indy Samra',      title: 'Finance Advisor',   cred: 'Chartered Accountant (CA)', photo: 'https://nova-portal-uploads.s3.us-east-2.amazonaws.com/uploads/6c7323d5c4fff3dd38c8105f843ce9f8.jpeg' },
  { initials: 'MK', name: 'Makis Mavrokefalos', title: 'Managing Director', cred: 'Apex DeFi Labs Inc.',       photo: '/members/makis.jpeg' },
  { initials: 'JF', name: 'Jamil French',    title: 'Corporate Advisor', cred: 'Apex DeFi Labs Inc.',       photo: '/members/jamil.jpeg' },
  { initials: 'SB', name: 'Steve Burnham',   title: 'Corporate Advisor', cred: 'Apex DeFi Labs Inc.',       photo: 'https://nova-portal-uploads.s3.us-east-2.amazonaws.com/uploads/sb.png' },
];

function TCard({ initials, name, title, cred, photo }: { initials: string; name: string; title: string; cred: string; photo: string | null }) {
  return (
    <div className="tcard">
      <div className="tcard-av">
        {photo
          ? <img src={photo} alt={name} style={{ width: '100%', height: '100%', objectFit: 'cover', borderRadius: '50%' }} />
          : initials}
      </div>
      <div className="tcard-name">{name}</div>
      <div className="tcard-title">{title}</div>
      <div className="tcard-cred">{cred}</div>
    </div>
  );
}

export default function TeamSection() {
  return (
    <section id="team" className="team-section">
      <div className="team-inner">
        <div style={{ textAlign: 'center' }}>
          <div className="eyebrow-label" style={{ justifyContent: 'center' }}>Leadership</div>
          <h2>
            Experienced Operators in{' '}
            <span>Fintech &amp; Capital Markets</span>
          </h2>
          <p className="lead">
            A cross-disciplinary leadership team with deep expertise in securities law, blockchain infrastructure, AI, and enterprise operations.
          </p>
        </div>

        <div className="team-grid">
          {teamMembers.map((m) => <TCard key={m.name} {...m} />)}
        </div>
      </div>
    </section>
  );
}
